export var QuestionAnswer;
(function (QuestionAnswer) {
    QuestionAnswer["Yes"] = "oui";
    QuestionAnswer["No"] = "non";
    QuestionAnswer["DoNotKnow"] = "ne sais pas";
})(QuestionAnswer || (QuestionAnswer = {}));
export class Question {
    constructor() {
        this.label = "";
        this.answer = QuestionAnswer.DoNotKnow;
        this.order = 0;
        this.mandatory = false;
    }
}
